import DropdownIcon from "/public/images/icons/chevronDown.svg?react";
import ErrorIcon from "/public/images/icons/inputError.svg?react";
import { useState } from "react";
import PropTypes from "prop-types";

export default function SelectInput({
  name,
  onChange,
  required,
  options,
  icon,
  defaultValue,
  value,
  label,
  disabled,
  error,
  placeholder,
  className,
  readonly
}) {
  const [internalValue, setInternalValue] = useState(defaultValue || "");

  const displayValue = value !== undefined ? value : internalValue;

  const handleChange = (e) => {
    if (value === undefined) {
      setInternalValue(e.target.value);
    }
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <label className="flex flex-col gap-1">
      {label && (
        <div>
          <span className="text-sportsBlack font-medium text-base leading-[26px mb-1]">
            {label}
            {required && "*"}
          </span>
        </div>
      )}

      <div className="relative">
        <select
          name={name}
          value={displayValue}
          onChange={handleChange}
          disabled={disabled}
          readOnly={readonly}
          className={`
            ${
              error && "border-sportsRed !border-2"
            } 
            focus:outline-sportsYellow
            ${
              displayValue !== ""
                ? "text-[#101820]"
                : "text-[#727272]"
            }
            bg-sportsLightGrey w-full border-solid border-[1px] border-[#E3E3E3] rounded-[4px] p-3 text-base leading-[26px] appearance-none ${className}
          `}
        >
          {placeholder && (
            <option value="" disabled>
              {placeholder}
            </option>
          )}
          {options && options.map((option) => option)}
        </select>

        {icon ? (
          <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
            {icon}
          </div>
        ) : (
          <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
            <DropdownIcon className="w-6 h-6" />
          </div>
        )}

        {error && (
          <span className="absolute top-1/2 -translate-y-1/2 right-9 cursor-pointer">
            <ErrorIcon className="w-6 h-6" />
          </span>
        )}
      </div>

      {error && (
        <p className="text-sportsRed text-base leading-[24px]">{error}</p>
      )}
    </label>
  );
}

SelectInput.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.node),
  icon: PropTypes.node,
  defaultValue: PropTypes.string,
  value: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string,
};
